module.exports = __webpack_public_path__ + "static/media/practice-question-header.0ece8a31.png";